var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sweet-button",class:[
          `sweet-button--${_vm.type}`,
          `sweet-button--${_vm.size}`,
          {
            'is-disabled': _vm.disabled,
            'is-round': _vm.round,
            'is-circle': _vm.circle
          }
        ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }